module.exports = __webpack_public_path__ + "static/icons/icon-past--white-e99a1e0cc5796b644e7c08a7c18e1cfb.svg";